import { useRef, useState } from "react";


const useAccordion = ({defaultOpen = 0}) => {
    const [openIndex, setOpenIndex] = useState(defaultOpen);
    const touchedRef = useRef(false);
    const itemRefs = useRef({});

    const getOuterHeight = (el) => {
        if (!el) return 0;
        const style = window.getComputedStyle(el);
        const mt = parseFloat(style.marginTop) || 0;
        const mb = parseFloat(style.marginBottom) || 0;
        return el.scrollHeight + mt + mb;
    };

    const toggle = (idx) => {
        // 첫 인터랙션 시 현재 열려있는 height 고정
        if (!touchedRef.current) {
            const el = itemRefs.current[openIndex];
            if (el) {
                el.parentElement.style.height = `${getOuterHeight(el)}px`;
            }
            touchedRef.current = true;
        }

        requestAnimationFrame(() => {
            setOpenIndex((prev) => (prev === idx ? -1 : idx));
        });
    };

    return {
        openIndex,
        toggle,
        touchedRef,
        itemRefs,
        getOuterHeight,
    };
}
export default useAccordion;
